import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLogin} from '../person/person-login';
import {SelectionItem} from '../selections/selection-item';
import {OrganizationPhoneService} from '../services/organization-phone-service';
import {OrganizationService} from '../services/organization-service';
import {PersonLoginService} from '../services/person-login-service';
import {SelectionService} from '../services/selection-service';
import {OrganizationPhone} from './organization-phone';
import { NgClass } from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'organization-phones',
    templateUrl: './organization-phones.component.html',
    styleUrls: ['./organization-phones.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, NgClass]
})
export class OrganizationPhonesComponent implements OnInit, OnChanges {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly phoneService = inject(OrganizationPhoneService);
  private readonly organizationService = inject(OrganizationService);
  private readonly router = inject(Router);
  private readonly selectionService = inject(SelectionService);


  public personLogin!: PersonLogin;
  readonly organizationId = input.required<string>({ alias: 'organization-id' });
  readonly phones = signal<OrganizationPhone[]>(undefined!);
  public readonly selectedPhone = signal<OrganizationPhone>(undefined!);
  readonly selectedRowId = signal<number>(undefined!);
  readonly phoneTypes = signal<SelectionItem[]>(undefined!);
  readonly isNew = signal<boolean>(undefined!);

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['organizationId'].firstChange) {
      this.initialize();
    }
  }

  private initialize(): void {
    const idString: string = this.organizationId();
    if (idString && idString.length > 0) {
      this.organizationService.getOrganization(idString).subscribe(result => {
        let userOrg = this.personLogin.person.primaryOrgUnitId;
        if (this.personLogin.roles.length === 0 && result.orgUnitId !== userOrg && result.controllingOrgId !== userOrg) {
          this.backToOrganizationMaster();
        } else {
          this.loadOrganizationPhones();
        }
      });
    } else {
      this.backToOrganizationMaster();
    }
  }

  private loadOrganizationPhones(): void {
    this.phoneService.getOrganizationPhones(this.organizationId()).subscribe(results => {
      this.phones.set(results);
    });
  }

  public selectPhone(index: number, phone: OrganizationPhone) {
    this.selectedPhone.set(phone);
    this.selectedRowId.set(index);
    this.isNew.set(false);
  }

  private backToOrganizationMaster(): void {
    this.router.navigate(['organization']);
  }

  public backToOrganizationDetail(): void {
    this.router.navigate(['organization/' + this.organizationId()]);
  }

  public save(): void {
    this.phoneService.save(this.selectedPhone()).subscribe(() => {
      this.isNew.set(false);
      this.loadOrganizationPhones();
      this.selectedPhone.set(null!);
      this.selectedRowId.set(-1);
    });
  }

  public deletePhone(): void {
    this.phoneService.deletePhone(this.selectedPhone()).subscribe(() => {
      this.loadOrganizationPhones();
      this.selectedRowId.set(-1);
      this.selectedPhone.set(null!);
    });
  }

  public newPhone(): void {
    this.isNew.set(true);
    this.selectedRowId.set(-1);
    this.selectedPhone.set(new OrganizationPhone());
    this.selectedPhone().relationshipTypeCode = "BUSNS1";
    this.selectedPhone().orgUnitId = this.organizationId();
  }

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.selectionService.getPhoneTypes().subscribe(result => this.phoneTypes.set(result));
      this.initialize();
    }
  }

}
